import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ed3cef0e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-title"
}, "参数设置：", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "43px"
  }
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dialog-tips"
}, [/*#__PURE__*/_createElementVNode("div", null, "注：1.这里编辑的列表只保存在本地，当浏览器清除缓存时，列表数据会消失；"), /*#__PURE__*/_createElementVNode("div", null, "2.禁止上传到根目录(/)，如果设置根目录，会修改为默认目录；"), /*#__PURE__*/_createElementVNode("div", null, "3.目录前缀须是dcw-xxx开头；")], -1));
const _hoisted_4 = {
  class: "dialog-add"
};
const _hoisted_5 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_slider = _resolveComponent("el-slider");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_Edit = _resolveComponent("Edit");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_form = _resolveComponent("el-form");
  const _component_Minus = _resolveComponent("Minus");
  const _component_el_input = _resolveComponent("el-input");
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
    class: "form",
    size: "small"
  }, {
    default: _withCtx(() => [_hoisted_1, _createVNode(_component_el_form_item, {
      label: "图片格式",
      class: "form-item"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.options.format,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.options.format = $event),
        placeholder: "点击选择",
        class: "select-format"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "保持图片原格式",
          value: ""
        }), _createVNode(_component_el_option, {
          label: "png",
          value: "png"
        }), _createVNode(_component_el_option, {
          label: "jpg",
          value: "jpg"
        }), _createVNode(_component_el_option, {
          label: "webp",
          value: "webp"
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "图片质量",
      class: "form-item"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_slider, {
        modelValue: $data.options.quality,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.options.quality = $event),
        "show-input": "",
        size: "small",
        "show-stops": "",
        step: 5,
        min: 30
      }, null, 8, ["modelValue"])]),
      _: 1
    }), $props.type === 'single' ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 0,
      label: "切割份数",
      class: "form-item"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_slider, {
        modelValue: $data.options.divide,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.options.divide = $event),
        "show-input": "",
        size: "small",
        "show-stops": "",
        step: 1,
        min: 2,
        max: 15
      }, null, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
      label: "",
      class: "form-item switch-cdn"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _withDirectives(_createVNode(_component_el_form_item, {
      label: "CDN目录",
      class: "form-item switch-cdn switch-cdn-section"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tooltip, {
        class: "",
        content: $options.cdnDirTips(),
        placement: "bottom",
        effect: "light"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          class: "select-format",
          modelValue: $data.selectCdnItem,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.selectCdnItem = $event),
          placeholder: "/dcw-pied-piper"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.cdnDirList, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.key,
              label: item.label,
              value: item.key
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["content"]), _createVNode(_component_el_icon, {
        onClick: $options.showDialog
      }, {
        default: _withCtx(() => [_createVNode(_component_Edit)]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    }, 512), [[_vShow, $data.options.cdn]])]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    modelValue: $data.dialogFormVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.dialogFormVisible = $event),
    title: "编辑目录列表",
    top: "15vh"
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.confirmCdnList
    }, {
      default: _withCtx(() => [_createTextVNode("确 认")]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createElementVNode("div", null, [_hoisted_3, _createVNode(_component_el_form, {
      model: $props.form
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dialogCdnList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "form-item-wrap",
          key: item.key
        }, [_withDirectives(_createVNode(_component_el_icon, {
          class: "form-item-del",
          onClick: $event => $options.deleteCdnItem(index)
        }, {
          default: _withCtx(() => [_createVNode(_component_Minus)]),
          _: 2
        }, 1032, ["onClick"]), [[_vShow, index > 0]]), _createVNode(_component_el_form_item, {
          label: "项目名称",
          "label-width": 70
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: item.label,
            "onUpdate:modelValue": $event => item.label = $event,
            modelModifiers: {
              trim: true
            },
            disabled: index === 0,
            autocomplete: "off",
            maxlength: "20"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
          _: 2
        }, 1024), _createVNode(_component_el_form_item, {
          label: "CDN目录",
          "label-width": 80,
          class: "form-item-dir"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tooltip, {
            class: "",
            content: $options.cdnDirTips(item.value),
            placement: "bottom",
            effect: "light"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value,
              "onUpdate:modelValue": $event => item.value = $event,
              modelModifiers: {
                trim: true
              },
              disabled: index === 0,
              autocomplete: "off"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
            _: 2
          }, 1032, ["content"])]),
          _: 2
        }, 1024)]);
      }), 128))]),
      _: 1
    }, 8, ["model"]), _withDirectives(_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, {
      class: "dialog-add-icon",
      onClick: $options.addLocalCdnDir
    }, {
      default: _withCtx(() => [_createVNode(_component_Plus)]),
      _: 1
    }, 8, ["onClick"])], 512), [[_vShow, $options.showAddIcon]])])]),
    _: 1
  }, 8, ["modelValue"])]);
}